package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.AddEditServiceValidation
import com.essntl.features.service.ui.addeditservice.EditServiceSectionData
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing

@Composable
internal fun TitleSectionItem(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
    validation: AddEditServiceValidation,
) {
    Spacer(modifier = Modifier.height(2.spacing))

    EsInput(
        value = state.service.value.title,
        onValueChange = {
            validation.addEditServiceForm.title.validate(it)
            onEvent(
                AddEditServiceEvent.UpdateServiceFields(
                    state.service.value.copy(
                        title = it,
                    ),
                ),
            )
        },
        label = "Title",
        placeholder = "Enter title",
        message = "This field is required",
        enabled = enabled,
        state = validation.addEditServiceForm.title.state,
        modifier =
        Modifier
            .fillMaxWidth(),
    )
}
